import {
    hasResourceTokenAuthInfoBarRequest,
    ResourceTokenAuthInfoBarHost,
} from 'owa-app-auth-messagebar';
import { getApplicationSettings } from 'owa-application-settings';
import { observer } from 'owa-mobx-react';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import React from 'react';
import { MsalAuthInfoBar, lazyRecoverAccountAfterResourceTokenSignIn } from '../lazyComponents';
import { showMsalAuthInfoBar } from '../showMsalAuthInfoBar';

const AuthInfoBarHost: React.FunctionComponent = observer(function AuthInfoBarHost() {
    const mailboxInfo = getModuleContextMailboxInfo();

    if (!getApplicationSettings('PlatformType').isMonarch && showMsalAuthInfoBar()) {
        return <MsalAuthInfoBar />;
    }

    return hasResourceTokenAuthInfoBarRequest(mailboxInfo) ? (
        <ResourceTokenAuthInfoBarHost
            mailboxInfo={mailboxInfo}
            onSignInSucceeded={lazyRecoverAccountAfterResourceTokenSignIn.importAndExecute}
        />
    ) : null;
}, 'AuthInfoBarHost');

export default AuthInfoBarHost;
